import { render, staticRenderFns } from "./LayoutLogo.vue?vue&type=template&id=7f0ef6dc"
import script from "./LayoutLogo.vue?vue&type=script&lang=js"
export * from "./LayoutLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BasicLogo: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/basic/BasicLogo.vue').default})
